import { useState } from 'react';
import { Link } from 'react-router-dom';
import { identityApi, type IdentityRecord } from '../../api/identity';

export function IdentitySearchPage() {
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [status, setStatus] = useState('');
  const [tag, setTag] = useState('');
  const [items, setItems] = useState<IdentityRecord[]>([]);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function search() {
    setLoading(true);
    setError('');
    try {
      const params: Record<string, string> = { limit: '50' };
      if (email) params.email = email;
      if (displayName) params.display_name = displayName;
      if (status) params.status = status;
      if (tag) params.tag = tag;
      const res = await identityApi.search(params);
      setItems(res.items ?? []);
      setTotal(res.total ?? 0);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Search failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/identity" className="text-sm text-slate-600 hover:underline">← Directory</Link>
      <h1 className="mt-4 text-2xl font-semibold text-slate-900">Identity Search</h1>
      <p className="mt-1 text-sm text-slate-600">Search by email, display name, status, or tags.</p>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}

      <div className="mt-6 grid gap-3 rounded-xl border border-slate-200 bg-white p-4 md:grid-cols-2">
        <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2" />
        <input placeholder="Display name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2" />
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2">
          <option value="">Any status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="suspended">Suspended</option>
          <option value="archived">Archived</option>
        </select>
        <input placeholder="Tag" value={tag} onChange={(e) => setTag(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2" />
        <button type="button" onClick={() => void search()} className="rounded-lg bg-slate-900 px-4 py-2 text-white md:col-span-2 md:w-fit">
          {loading ? 'Searching…' : 'Search'}
        </button>
      </div>

      <p className="mt-4 text-sm text-slate-500">{total} results</p>
      <ul className="mt-4 space-y-3">
        {items.map((item) => (
          <li key={item.id} className="rounded-xl border border-slate-200 bg-white p-4">
            <Link to={`/identity/${item.id}`} className="font-medium text-slate-900 hover:underline">{item.display_name}</Link>
            <p className="text-sm text-slate-600">{item.email}</p>
            <p className="mt-1 text-xs text-slate-500">{item.status}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
